import React, { ReactElement, useEffect, useState } from 'react';

import {
  Navigate,
  useLocation,
  useNavigate,
} from '@interstellar/react-app-routing';

import { useGlobalProvider } from '../../context/GlobalContext';
import { ACCESS_TOKEN, DEPENDENCY_PAGES } from '../../utils/constant';

interface DependencyGuardProps {
  children?: React.ReactNode;
}

function DependencyGuard({ children }: DependencyGuardProps): ReactElement {
  const { globalState } = useGlobalProvider();
  const [hasDependency, setHasDependency] = useState(false);

  const navigate = useNavigate();
  const { state, pathname } = useLocation();

  useEffect(() => {
    const handleDependencyPage = (): void => {
      setHasDependency(false);
      let dependencyFound = false;
      switch (pathname) {
        case DEPENDENCY_PAGES.aboutYou:
          dependencyFound = !globalState?.organisationName;
          break;
        case DEPENDENCY_PAGES.registrationInProgress:
          dependencyFound = !state?.PegaCaseId;
          break;
        case DEPENDENCY_PAGES.smsOtp:
          dependencyFound = !state?.userData;
          break;
        case DEPENDENCY_PAGES.submitYourRegistration:
          dependencyFound = !globalState?.customerDetails?.documents?.length;
          break;
        default:
          if (DEPENDENCY_PAGES.idv.test(pathname)) {
            dependencyFound = !sessionStorage.getItem(ACCESS_TOKEN);
          }
          break;
      }
      if (dependencyFound) {
        navigate(-1);
      }
      setHasDependency(dependencyFound);
    };
    handleDependencyPage();
  }, [navigate, state, globalState, pathname]);

  if (hasDependency) return <Navigate to={pathname} replace />;

  return <>{children}</>;
}

export default DependencyGuard;
